function languageFromLocale(locale) {
  return locale.split('-')[0].toLowerCase();
}

export { languageFromLocale };
